import { captureMessage } from '@sentry/react';
export default function retry(fn, retriesLeft = 5, interval = 1000) {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch(error => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            // reject('maximum retries exceeded');
            captureMessage(`Request Chunk Retries #${retriesLeft}`);
            reject(error);
            return;
          }
          // Passing on "reject" is the important part
          retry(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });
}

export const sleep = milliseconds =>
  new Promise(resolve => setTimeout(resolve, milliseconds));
